import styled from 'styled-components'
import { colors } from '../theme'

export const Link = styled.a`
  color: black;
  text-decoration-color: black;
`

export const GreenLink = styled.a`
  color: ${colors.deepGreen};
  text-decoration-color: ${colors.deepGreen};
`

export const WhiteLink = styled.a`
  color: ${colors.white};
  text-decoration-color: ${colors.white};
`
